var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedinNew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3CAFE6"
    },
    d: "M469.779,503.983H42.221c-18.891,0-34.205-15.314-34.205-34.205V42.221 c0-18.891,15.314-34.205,34.205-34.205h427.557c18.891,0,34.205,15.314,34.205,34.205v427.557 C503.983,488.669,488.669,503.983,469.779,503.983z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1C9AD6"
    },
    d: "M42.221,452.676V8.017c-18.891,0-34.205,15.314-34.205,34.205v427.557 c0,18.891,15.314,34.205,34.205,34.205h427.557c18.891,0,34.205-15.314,34.205-34.205H59.324 C49.878,469.779,42.221,462.122,42.221,452.676z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.977,
    y: 196.142,
    style: {
      fill: "#FFFFFF"
    },
    width: 68.409,
    height: 230.881
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.977,
    y: 196.142,
    style: {
      fill: "#E5E5E5"
    },
    width: 25.653,
    height: 230.881
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M350.063,196.142c-17.102,0-58.076,2.494-76.96,42.756c0-8.551,0-42.756,0-42.756h-68.409v230.881 h68.409V315.858c0-25.653,21.644-42.756,42.756-42.756c23.613,0,42.756,17.102,42.756,42.756v33.766v77.399h68.409V264.551 C427.023,226.77,388.187,196.142,350.063,196.142z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 204.693,
    y: 196.142,
    style: {
      fill: "#E5E5E5"
    },
    width: 25.653,
    height: 230.881
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5E5E5"
    },
    d: "M384.267,315.858c0-25.653-19.143-42.756-42.756-42.756c-4.154,0-8.326,0.671-12.351,1.93 c17.098,5.139,29.453,20.219,29.453,40.825v33.766v77.399h25.653v-77.399V315.858z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 119.182,
    cy: 119.182,
    r: 34.205
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5E5E5"
    },
    d: "M136.284,136.284c-18.891,0-34.205-15.314-34.205-34.205c0-5.018,1.089-9.778,3.03-14.072 c-11.869,5.367-20.133,17.301-20.133,31.174c0,18.891,15.314,34.205,34.205,34.205c13.873,0,25.807-8.264,31.174-20.133 C146.062,135.195,141.302,136.284,136.284,136.284z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M503.983,92.994c4.428,0,8.017-3.589,8.017-8.017V42.221C512,18.941,493.059,0,469.779,0H42.221C18.941,0,0,18.941,0,42.221 v427.557C0,493.059,18.941,512,42.221,512h427.557c23.28,0,42.221-18.941,42.221-42.221V119.182c0-4.427-3.588-8.017-8.017-8.017 s-8.017,3.589-8.017,8.017v350.597c0,14.44-11.747,26.188-26.188,26.188H42.221c-14.44,0-26.188-11.748-26.188-26.188V42.221 c0-14.44,11.748-26.188,26.188-26.188h427.557c14.441,0,26.188,11.748,26.188,26.188v42.756 C495.967,89.405,499.555,92.994,503.983,92.994z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M153.386,238.898c4.427,0,8.017-3.589,8.017-8.017v-34.739c0-4.427-3.589-8.017-8.017-8.017H84.977 c-4.427,0-8.017,3.589-8.017,8.017v230.881c0,4.427,3.589,8.017,8.017,8.017h68.409c4.427,0,8.017-3.589,8.017-8.017V266.154 c0-4.427-3.589-8.017-8.017-8.017c-4.427,0-8.017,3.589-8.017,8.017v152.852H92.994V204.159h52.376v26.722 C145.37,235.308,148.959,238.898,153.386,238.898z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M358.614,435.04h68.409c4.428,0,8.017-3.589,8.017-8.017V264.551c0-20.236-9.586-39.579-26.99-54.465 c-16.319-13.955-37.454-21.96-57.987-21.96c-33.891,0-55.359,11.268-68.944,25.151v-17.134c0-4.427-3.588-8.017-8.017-8.017h-68.409 c-4.427,0-8.017,3.589-8.017,8.017v230.881c0,4.427,3.589,8.017,8.017,8.017h68.409c4.428,0,8.017-3.589,8.017-8.017V315.858 c0-21.457,18.032-34.739,34.739-34.739c20.129,0,34.739,14.61,34.739,34.739v111.165C350.597,431.45,354.185,435.04,358.614,435.04z  M315.858,265.086c-24.418,0-50.772,19.412-50.772,50.772v103.148H212.71V204.159h52.376v34.739c0,3.656,2.573,6.926,6.125,7.789 c3.66,0.888,7.55-0.973,9.15-4.385c11.871-25.31,35.323-38.143,69.703-38.143c32.545,0,68.944,25.828,68.944,60.392v154.455H366.63 V315.858C366.63,286.912,344.803,265.086,315.858,265.086z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M119.182,76.96c-23.281,0-42.221,18.941-42.221,42.221s18.941,42.221,42.221,42.221s42.221-18.941,42.221-42.221 S142.462,76.96,119.182,76.96z M119.182,145.37c-14.44,0-26.188-11.748-26.188-26.188s11.748-26.188,26.188-26.188 s26.188,11.748,26.188,26.188S133.621,145.37,119.182,145.37z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinNew);
export default __webpack_public_path__ + "static/media/linkedin-NEW.64848ad4e3e113ab92ad3e9452c5a69f.svg";
export { ForwardRef as ReactComponent };